
import { defineComponent } from 'vue';

import ModContent from '../components/mod-content.vue';

// TODO: Remove dependency
import CovidEndpointFooter from '@/applications/covid-hub/modules/endpoint/components/covid-endpoint-footer.vue';
import { covidEndpointComposition } from '@/applications/covid-hub/modules/endpoint/services';

export default defineComponent({
	components: {
		ModContent,
		CovidEndpointFooter
	},
	setup () {
		return { ...covidEndpointComposition() }
	},
})
